import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";

const firebaseConfig = {
  apiKey: "AIzaSyCUr9-1a4Gxhho6Vwe86ePM9ZRT4E5bjJ8",
  authDomain: "zengatrivi-challenge-template.firebaseapp.com",
  projectId: "zengatrivi-challenge-template",
  storageBucket: "zengatrivi-challenge-template.firebasestorage.app",
  messagingSenderId: "875260404687",
  appId: "1:875260404687:web:d0b528298ff31865f268ba",
  databaseURL: "https://zengatrivi-challenge-template-default-rtdb.firebaseio.com/",
};

const app = initializeApp(firebaseConfig);
export const db = getDatabase(app);
